import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  updateCoachCard,
  clearCoachCardUpdateState,
  clearCoachCardUpdateError,
} from "../redux/Slices/coachCardUpdateSlice";
import Loader from "./Common/Loader";

function CoachCardUpdateConfirmation() {
  const location = useLocation();
  const { id: urlId } = useParams();
  const searchParams = new URLSearchParams(location.search);
  const queryId = searchParams.get("id");
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector(
    (state) => state.coachCardUpdate
  );
  const id = urlId || queryId;

  useEffect(() => {
    if (id) {
      dispatch(updateCoachCard(id));
    }

    return () => {
      dispatch(clearCoachCardUpdateState());
      dispatch(clearCoachCardUpdateError());
    };
  }, [id, dispatch]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-green-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        {loading && <Loader />}
        {success && (
          <>
            <h2 className="text-green-600 mb-4">
              Card Details Updated Successfully!
            </h2>
            <p className="text-gray-700">
              Your card details have been securely updated for future
              transactions.
              <br />
              Thank you for updating your payment information.
            </p>
          </>
        )}
        {error && (
          <p className="text-red-600">Failed to update card details: {error}</p>
        )}
      </div>
    </div>
  );
}

export default CoachCardUpdateConfirmation;
